import { useEffect } from 'react';
import '../../css/base.css';
import scenery5_large from '../../img/scenery5_large.jpg';

const BookingError = () => {

  useEffect(() => {
    window.scrollTo(0,0);
  }, []);

  return (
    <div className="row">
      <div className="col-12 col-md-6 imagesBackgroundColour">
        <div className="row">
          <div className="col-12 col-md-8">
            <div className="keyText">
              <h4 className="availabilityCalendarTextBox">Booking Unsuccessful</h4>
            </div>            
          </div>
        </div>
        <div className="row" style={{"margin-top": "1rem"}}>
        <div className="col-12 col-md-8">
          <div className="generalText">
            <div className="generalTextBox">
              There has been a problem when booking your stay at Shore Cottage.
            </div>
          </div>
        </div>
      </div>
      <div className="row" style={{"margin-top": "0"}}>
        <div className="col-12 col-md-8">
          <div className="generalText">
            <div className="generalTextBox">
              Please contact us on any of the email or phone numbers below and we will investigate the issue as soon as possible.
            </div>
          </div>
        </div>
      </div>          
      </div>
      <div className="col-12 col-md-6 imagesBackgroundColour">
        <img src={scenery5_large} alt="Welcome Door" className="gallery-image" />
      </div>
    </div>

  );
}

export default BookingError